<template>
    <form v-on:submit.prevent="onFormSubmit" novalidate>
        <div class="row">
            <label class="sr-only" for="createFolderFormNameInput">Name</label>
            <div class="input-group col-12 col-sm pr-sm-0 mr-sm-2 mb-2 mb-md-0">
                <input type="text"
                       class="form-control"
                       v-bind:class="{'is-invalid': context.validationErrorMessage}"
                       id="createFolderFormNameInput"
                       placeholder="Enter a folder name"
                       v-model="name"
                       ref="nameInput"
                       :disabled="!currentState.matches('editing')"
                />
                <div class="invalid-feedback"
                     v-bind:class="{'d-block': context.validationErrorMessage}">
                    {{ context.validationErrorMessage }}
                </div>
            </div>
            <div class="col-12 col-sm-auto pl-sm-0">
                <b-button
                    v-bind:class="{'btn-block': $mq === 'xs' || $mq === 'sm'}"
                    ref="button"
                    class="d-md-block"
                    type="submit"
                    style="min-width: 59.5px;"
                    :variant="this.getButtonVariant()"
                    :disabled="!currentState.matches('editing')"
                >
                    <span
                        v-if="this.isSubmitting()"
                        class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                    <fa-icon
                        v-if="currentState.matches('submitted')"
                        icon="check"
                        class="color-success"/>
                    {{ currentState.matches('editing') ? 'Create' : '' }}
                </b-button>
            </div>
        </div>
    </form>
</template>

<script>
import {createFolderFormMachine} from "./CreateFolderFormMachine";
import {interpret} from "xstate";
import {XSTATE_DEBUG_ENABLED} from "../../../../constants.js";

export default {
    name: "CreateFolderForm",
    props: {
        submitRequest: {
            type: Function
        }
    },
    created() {
        this.formService
            .onTransition((state) => {
                this.currentState = state;
                this.context = state.context;
                switch (state.event.type) {
                    case 'error.platform.validating': {
                        this.focusInput();
                        break;
                    }
                }
            })
            .start();
    },
    data() {
        const machine = createFolderFormMachine()
            .withConfig({
                services: {
                    execCreateFolderRequest: async (ctx, {data: folderName}) => {
                        return this.submitRequest(folderName);
                    },
                    onDone: (ctx, event) => {
                        const {data: {folder}} = event;
                        this.$emit('done', {folder});
                    }
                }
            });
        const formService = interpret(machine, {
            devTools: XSTATE_DEBUG_ENABLED
        });
        return {
            formService,
            currentState: machine.initialState,
            context: machine.context,
            name: null,
            validationErrors: []
        };
    },
    methods: {
        onFormSubmit() {
            this.formService.send({type: 'SUBMIT', name: this.name});
        },
        focusInput() {
            this.$nextTick(() => {
                this.$refs.nameInput.focus();
            });
        },
        getButtonVariant() {
            switch (this.currentState.value) {
                case 'submitted': {
                    return 'success'
                }
                default: {
                    return 'primary';
                }
            }
        },
        isSubmitting() {
            return this.currentState.matches('validating')
                || this.currentState.matches('submitting');
        }
    }
}
</script>

<style scoped>

</style>
